import { Color } from './color';
/**
 * ⬡
 */
export const HollowHexagon = (options, context) => {
    return Color(Object.assign({ colorAttribute: 'stroke', symbol: 'hexagon' }, options), context);
};
HollowHexagon.props = Object.assign({ defaultMarker: 'hollowHexagon' }, Color.props);
//# sourceMappingURL=hollowHexagon.js.map